import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { api } from 'services';
import { saveRequest } from '@redux/modules/save/actions';
import { getSectionKeys } from '@redux/modules/section/selectors';
import env from 'config/environment';
import { i18n } from 'config/locales';
import { logoutRequest } from '../../redux/modules/authentication/actions';

export class Logout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      saml: false,
    };
  }

  UNSAFE_componentWillMount() { // eslint-disable-line react/sort-comp
    if ((env.SamlEnabled() || env.Saml2Enabled()) && env.SamlSLOEnabled()) {
      api.samlSLO().then((response) => {
        this.setState({ saml: response.data || {} });
      }).catch((err) => console.error(err));
    }
  }

  logout = () => {
    const { sectionKey, subsectionKey, dispatch } = this.props;

    dispatch(saveRequest(sectionKey, subsectionKey, false));
    dispatch(logoutRequest());
  };

  logoutSAMLSLO() {
    const { saml } = this.state;

    return (
      <div id="saml" className="auth saml">
        <form method="post" action={saml.URL}>
          <input type="hidden" name="SAMLRequest" value={saml.Base64XML} />
          <button type="submit" className="usa-button-big">
            <span>{this.props.buttonText}</span>
          </button>
        </form>
      </div>
    );
  }

  logoutSAML() {
    return (
      <div id="saml" className="auth saml">
        <button type="button" className="usa-button-big" onClick={this.logout}>
          <span>{this.props.buttonText}</span>
        </button>
      </div>
    );
  }

  logoutBasic() {
    if (!env.BasicAuthenticationEnabled()) {
      return null;
    }

    return (
      <button type="button" onClick={this.logout} className="logout">
        {this.props.buttonText}
      </button>
    );
  }

  render() {
    const { saml } = this.state;

    if ((env.SamlEnabled() || env.Saml2Enabled()) && saml) {
      return this.logoutSAMLSLO();
    }

    if ((env.SamlEnabled() || env.Saml2Enabled()) && env.SamlLogoutEnabled()) {
      return this.logoutSAML();
    }

    return this.logoutBasic();
  }
}

Logout.propTypes = {
  buttonText: PropTypes.string,
  sectionKey: PropTypes.string,
  subsectionKey: PropTypes.string,
  dispatch: PropTypes.func,
};

Logout.defaultProps = {
  buttonText: i18n.t('app.logout'),
  section: {},
  dispatch: () => { },
};

/**
 * @param {import('types/state').RootState} state
 */
const mapStateToProps = (state) => ({
  ...getSectionKeys(state),
});

export default connect(mapStateToProps)(Logout);
